<script setup lang="ts">
  import { computed } from "vue";
  import { Separator } from "@/components/ui/separator";
  import TopCreatives from "./components/TopCreatives.vue";
  import TopCampaigns from "./components/TopCampaigns.vue";
  import TopAudiences from "./components/TopAudiences.vue";
  import type { Histo, HistoCreative, HistoCampaign, HistoAudience } from "@/components/Admin/Histo/HistoDataTable/types";

  const props = defineProps<{
    histo: Histo;
  }>();

  const isMultiCountry = computed(() => {
    try {
      const countryMetrics = JSON.parse(props.histo.country_metrics || "{}");
      return Object.keys(countryMetrics).length > 1;
    } catch {
      return false;
    }
  });

  const adsTopCreas = computed<Record<string, HistoCreative[]>>(() => {
    try {
      return JSON.parse(props.histo.ads_top_creas || "{}");
    } catch {
      return {};
    }
  });

  const adsTopCampaigns = computed<Record<string, HistoCampaign[]>>(() => {
    try {
      return JSON.parse(props.histo.ads_top_campaigns || "{}");
    } catch {
      return {};
    }
  });

  const adsTopAudiences = computed<Record<string, HistoAudience[]>>(() => {
    try {
      return JSON.parse(props.histo.ads_top_audiences || "{}");
    } catch {
      return {};
    }
  });
</script>

<template>
  <div class="space-y-6">
    <TopCreatives
      :creatives="adsTopCreas"
      :is-multi-country="isMultiCountry" />

    <Separator />

    <TopCampaigns
      :campaigns="adsTopCampaigns"
      :is-multi-country="isMultiCountry" />

    <Separator />

    <TopAudiences
      :audiences="adsTopAudiences"
      :is-multi-country="isMultiCountry" />
  </div>
</template>
